<template>
  <div class="guests-table">
    <div v-if="loading">
      <div class="d-flex v-expansion-panel-header" v-for="i in 5" :key="i">
        <v-skeleton-loader type="heading" :loading="true" max-width="40%" />
        <v-skeleton-loader type="chip" :loading="true" class="mr-auto" />
        <v-skeleton-loader type="button" :loading="true" class="flex-grow-0" />
      </div>
    </div>
    <v-expansion-panels flat multiple accordion v-else>
      <v-expansion-panel v-for="(group, index) in guestsToShow" :key="index">
        <v-expansion-panel-header>
          <div class="d-flex align-center guest-record">
            <h3 class="parking-subtitle mr-4">
              {{ group.group_name }}
              <span v-if="!$store.state.guests.place && isCompany">
                ({{ group.place_name }})
              </span>
            </h3>
            <div class="streaming-subtitle mr-4">
              {{ $tc("car_qty", getCars(group), { n: getCars(group) }) }}
            </div>
            <svg
              width="18px"
              viewBox="0 0 20 20"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            >
              <g
                id="Page-1"
                stroke="none"
                stroke-width="1"
                fill="none"
                fill-rule="evenodd"
              >
                <g
                  id="1_12-Additional-search-Show-more"
                  transform="translate(-18.000000, -873.000000)"
                  fill-rule="nonzero"
                >
                  <g id="Group-2-Copy-3" transform="translate(0.000000, 861.000000)">
                    <g id="Combined-Shape" transform="translate(16.000000, 10.000000)">
                      <path
                        d="M15,4 L15,5 C15,6.0543618 15.8158778,6.91816512 16.8507377,6.99451426 L17,7 C18.0543618,7 18.9181651,6.18412221 18.9945143,5.14926234 L19,5 L19,4 C20.6568542,4 22,5.34314575 22,7 L22,18 C22,20.1421954 20.3160315,21.8910789 18.1996403,21.9951047 L18,22 L6,22 C3.85780461,22 2.10892112,20.3160315 2.00489531,18.1996403 L2,18 L2,7 C2,5.34314575 3.34314575,4 5,4 L5,5 C5,6.1045695 5.8954305,7 7,7 C8.0543618,7 8.91816512,6.18412221 8.99451426,5.14926234 L9,5 L9,4 L15,4 Z M20,9 L4,9 L4,18 C4,19.0016437 4.73632971,19.8313084 5.69722565,19.9772306 L5.85073766,19.9945143 L6,20 L18,20 C19.0543618,20 19.9181651,19.1841222 19.9945143,18.1492623 L20,18 L20,9 Z M18.276953,15.2890567 L18.276953,17.7890567 L15.776953,17.7890567 L15.776953,15.2890567 L18.276953,15.2890567 Z M8.26702667,15.2821605 L8.26702667,17.7821605 L5.76702667,17.7821605 L5.76702667,15.2821605 L8.26702667,15.2821605 Z M13.2751767,15.2821605 L13.2751767,17.7821605 L10.7751767,17.7821605 L10.7751767,15.2821605 L13.2751767,15.2821605 Z M18.2645887,11.0068962 L18.2645887,13.5068962 L15.7645887,13.5068962 L15.7645887,11.0068962 L18.2645887,11.0068962 Z M8.25466232,11 L8.25466232,13.5 L5.75466232,13.5 L5.75466232,11 L8.25466232,11 Z M13.2628124,11 L13.2628124,13.5 L10.7628124,13.5 L10.7628124,11 L13.2628124,11 Z M7,2 C7.55228475,2 8,2.44771525 8,3 L8,5 C8,5.55228475 7.55228475,6 7,6 C6.44771525,6 6,5.55228475 6,5 L6,3 C6,2.44771525 6.44771525,2 7,2 Z M17,2 C17.5522847,2 18,2.44771525 18,3 L18,5 C18,5.55228475 17.5522847,6 17,6 C16.4477153,6 16,5.55228475 16,5 L16,3 C16,2.44771525 16.4477153,2 17,2 Z"
                      ></path>
                    </g>
                  </g>
                </g>
              </g>
            </svg>
          </div>
          <v-btn
            v-show="!isReadonly"
            text
            class="flat-btn"
            @click.stop="openGuestForm(group, 0)"
            >{{ $t("change") }}</v-btn
          >
        </v-expansion-panel-header>
        <v-expansion-panel-content class="guest-flow my-0">
          <GuestTree
            @clickedEdit="(tab) => openGuestForm(group, tab)"
            :show="true"
            :checkTab="false"
            :reading="true"
            :group="group"
            :hasSearch="searchValue"
          />
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
export default {
  name: "GuestsTable",
  mounted() {},
  components: {
    GuestTree: () => import("./GuestTree.vue"),
  },
  data() {
    return {};
  },
  props: {
    searchValue: {
      type: String,
      default: "",
    },
  },
  computed: {
    loading() {
      return this.$store.state.guests.loading;
    },
    isReadonly() {
      return this.$store.getters["app/isReadonly"];
    },
    records() {
      return this.$store.state.guests.guest_list;
    },
    allgroups() {
      return this.groups.concat(this.subgroups);
    },
    groups() {
      return this.$store.state.guests.groups;
    },
    subgroups() {
      return this.$store.state.guests.subgroups;
    },
    places() {
      return [...this.$store.state.app.places];
    },
    isCompany() {
      return this.$store.getters["app/isCompany"];
    },
    guests() {
      let result = [];
      let all = [...this.records].slice().sort((a, b) => a.group_id - b.group_id);
      let byGroups = all.groupBy("group_id");
      byGroups.map((group) => {
        let bySub = group
          .sort((a, b) => a.subscription.price_option_id - b.subscription.price_option_id)
          .map((i) => {
            return { ...i, price_type: i.subscription.price_option_id };
          })
          .groupBy("price_type");
        let subgroups = [];
        bySub.map((sub) => {
          let price = sub[0].price_type;
          let priceObj = this.$t(`monthly_price_options`).filter(
            (i) => i.id === price
          )[0];
          let group_name = priceObj ? priceObj.text : "N/A";
          subgroups.push({
            group_name,
            guests: this.reformatGuests(sub),
          });
        });
        let groupObj = this.groups.filter((i) => i.group_id === group[0].group_id)[0];
        result.push({
          ...groupObj,
          subgroups,
        });
      });

      let empty = this.groups
        .filter((i) => this.records.filter((g) => g.group_id === i.group_id).length === 0)
        .map((i) => {
          return {
            ...i,
            subgroups: [],
          };
        });

      return result.concat(empty);
    },
    guestsToShow() {
      return this.search(this.searchValue);
    },
  },
  methods: {
    reformatGuests(guests) {
      let result = guests || [];
      return result.map((guest) => {
        return {
          ...guest,
          subscription: guest.subscription || {},
        };
      });
    },
    search(value) {
      let newGuests = [...this.guests];
      newGuests.map((g) => {
        g.group_name = g.group_name || "N/A";
      });
      if (value) {
        newGuests.map((group) => {
          group.show = false;
          if (group.group_name.toLowerCase().includes(value.toLowerCase())) {
            group.show = true;
          }
          group.subgroups.map((subgroup) => {
            subgroup.guests.map((p) => {
              p.show = false;
              p.cars.map((c) => {
                c.show = false;
              });
              let hasCar =
                p.guest_name.toLowerCase().includes(value.toLowerCase()) ||
                p.phone.toLowerCase().includes(value.toLowerCase());
              p.cars.map((car) => {
                if (car.plate_number.toLowerCase().includes(value.toLowerCase())) {
                  hasCar = true;
                }
              });
              if (hasCar) {
                group.show = true;
                subgroup.show = true;
                p.show = true;
                p.cars.map((c) => {
                  c.show = true;
                });
              }
            });
          });
        });
        newGuests = newGuests.filter((i) => i.show === true);
      }
      let result = newGuests.sort((a, b) => a.group_name.localeCompare(b.group_name));
      return result;
    },
    openGuestForm(guestObj, tab) {
      this.$store.commit("guests/set_current_place", guestObj.place_id);
      this.$store.commit("guests/set_current_group", guestObj);
      this.$store.commit("guests/set_guest_tab", tab);
      if (tab === 0) {
        this.$store.commit("guests/set_guest_tree", true);
      }
      this.$router.push("/platform/your-parking/cyberport-guest");
    },
    getCars(group) {
      let total = 0;
      group.subgroups.map((dep) => {
        if (dep.guests) {
          dep.guests.map((guest) => {
            total += guest.cars ? guest.cars.length : 0;
          });
        }
      });
      return total;
    },
  },
};
</script>

<style lang="scss" scoped>
.streaming-subtitle {
  color: $grey;
}
@media print, screen and (max-width: 576px) {
  .guest-record .parking-subtitle {
    font-size: 14px !important;
    width: 86px;
  }
  .guest-record .streaming-subtitle {
    width: 80px;
  }
  .v-expansion-panel-header .flat-btn {
    margin: 0 8px;
  }
}
</style>

<style lang="scss">
@import "@/scss/_modal.scss";
.guests-table .v-skeleton-loader__chip {
  width: 36px;
}
</style>
